import React from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from 'tss-react/mui'
import { Typography, Link, Box } from '@mui/material'
import { useCurrentUser } from '@utils/useCurrentUser'
import messages from '@src/utils/messages'
import { homeRoute, loginRoute, useRouter, registerRoute } from '@src/routes'
import { useCheckUserCountry } from '@utils/useCheckUserCountry'
import countriesMap from '@localization/countries.json'
import { Linq } from '@src/components/Linq'

const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    backgroundColor: theme.palette.primary.light,
    padding: theme.spacing(2, 0),
    userSelect: 'none',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      alignItems: 'center',
      padding: theme.spacing(2),
    },
  },
  contentContainer: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  title: {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.pxToRem(14),
  },
  link: {
    cursor: 'pointer',
  },
}))

interface SignInBannerProps {
  mb?: number
  mr?: number
  signInGAEvent?: () => void
}

const SignInBanner: React.FC<SignInBannerProps> = ({
  mb,
  mr,
  signInGAEvent,
}) => {
  const { classes } = useStyles()
  const router = useRouter()
  const { userIsLoggedIn, currentUser } = useCurrentUser()
  const isHKUser = useCheckUserCountry(countriesMap.HK.countryCode)

  const affiliateAccount =
    currentUser?.__typename === 'LoggedInUser' &&
    currentUser.soldToPartners.length < 1

  return !userIsLoggedIn ? (
    <Box mb={mb} mr={mr} data-testid="non-logged-in-banner">
      <div className={classes.container}>
        <div className={classes.contentContainer}>
          <Typography
            variant="body1"
            component="span"
            className={classes.title}
          >
            <FormattedMessage
              id="SIGN_IN_VIEW_ORG_CONTRACT_PRICING"
              defaultMessage="{signInLink} to View Organizational & Contract Pricing."
              values={{
                signInLink: (
                  <Linq
                    href={`${loginRoute.index()}?redirect=${encodeURIComponent(
                      router.asPath || homeRoute.index()
                    )}`}
                    onClick={() => signInGAEvent?.()}
                  >
                    <FormattedMessage id="SIGN_IN" defaultMessage="Sign In" />
                  </Linq>
                ),
              }}
            />
          </Typography>
        </div>
      </div>
    </Box>
  ) : affiliateAccount && !isHKUser ? (
    <Box mb={mb} mr={mr} data-testid="logged-in-banner">
      <div className={classes.container}>
        <div className={classes.contentContainer}>
          <Link
            href={`${registerRoute.linkProfile()}?returnUrl=${encodeURIComponent(
              router.asPath || homeRoute.index()
            )}`}
            className={classes.link}
          >
            <FormattedMessage {...messages.LINK_YOUR_ACCOUNT} />
          </Link>
          <Typography
            variant="body1"
            component="span"
            className={classes.title}
          >
            <FormattedMessage {...messages.VIEW_ORG_CONTRACT_PRICING} />
          </Typography>
        </div>
      </div>
    </Box>
  ) : null
}

export default SignInBanner
